import { render, staticRenderFns } from "./UserLoader.vue?vue&type=template&id=3e1dd57e&"
import script from "./UserLoader.vue?vue&type=script&lang=ts&"
export * from "./UserLoader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports